import React, { Component, Fragment } from 'react'
import Breadcrumb from '../common/breadcrumb';
import { ToastContainer, toast } from 'react-toastify';

class Banner extends Component {
    constructor(props) {
        super(props)
        this.state = {
            mode: "",      //CREATE, UPDATE
            option: {
                title: "",
                subTitle: "",
                banner: ""
            },
        }
    }
    inputHandler = (e) => {
        let _obj = this.state.option;
        _obj[e.target.name] = e.target.value
        this.setState({ option: _obj })
    }
    componentDidMount = () => {
        if (!localStorage.getItem('userInfo')) {
            window.location.href = '/admin';
        }
        this.fetchBanner()
    }
    fetchBanner = () => {
       
        const url = `${process.env['REACT_APP_HOST']}/api/homebanner/`;
        const params = {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
            },
        };
        fetch(url, params)
            .then(response => response.json())
            .then(data => {
                console.log("data");
                console.log(data);
                if (data.error == false) {
                    this.setState({ mode: "UPADTE", option: data.home })
                    return
                }
                this.setState({ mode: "CREATE" })
            })
    }
    saveBannerData = () => {
        if(this.state.option.title.length > 15 || this.state.option.subTitle.length > 15){
            toast.error("Title and Sub title length should be below 50 characters.")
            return
        }
        const url = `${process.env['REACT_APP_HOST']}/api/homebanner/`;
        const params = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                ...this.state.option
            }),
        };
        fetch(url, params)
            .then(response => response.json())
            .then(data => {
                console.log("data");
                console.log(data);
                if (data.error == false) {
                    setTimeout(() => window.location.reload(), 3000)
                    toast.success("Successfully Created !")
                    return
                }
                //  toast.success("Successfully Created !")
                toast.error("Please Retry.")
            })
    }
    updateBannerData = () => {
        if(this.state.option.title.length > 50 || this.state.option.subTitle.length > 50){
            toast.error("Title and Sub title length should be below 50 characters.")
            return
        }
        const url = `${process.env['REACT_APP_HOST']}/api/homebanner/${this.state.option._id}`;
        const params = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                ...this.state.option
            }),
        };
        fetch(url, params)
            .then(response => response.json())
            .then(data => {
                console.log("data");
                console.log(data);
                if (data.error == false) {
                    toast.success("Successfully Updated !")
                    return
                }
                //  toast.success("Successfully Created !")
                toast.error("Please Retry.")
            })
    }
    render() {
        return (
            <Fragment>
                <ToastContainer />
                <Breadcrumb title="Banner" parent="Settings" />
                <div className="container-fluid">
                    <div className="row">

                        <div className="col-xl-8">
                            <div className="card profile-card">
                                <div className="card-body">
                                    {this.state.mode != "" ?
                                        <div className="digital-add needs-validation p-3">
                                            <div className="form-group">
                                                <label className="col-form-label pt-0"> Title <span>*</span></label>
                                                <input type="text" name="title" value={this.state.option.title} onChange={this.inputHandler} className="form-control"  ></input>
                                            </div>
                                            <div className="form-group">
                                                <label className="col-form-label pt-0"> Sub Title <span>*</span></label>
                                                <input type="text" name="subTitle" value={this.state.option.subTitle} onChange={this.inputHandler} className="form-control" ></input>
                                            </div>
                                            {this.state.mode == "CREATE" ?
                                                <button type="button" onClick={this.saveBannerData} class="btn btn-primary">Save</button>
                                                :
                                                <button type="button" onClick={this.updateBannerData} class="btn btn-primary">UPDATE</button>
                                            }
                                        </div>
                                        : null}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default Banner
